import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { PainelResumoDTO } from '../models/painel.model';
import { PainelService } from './painel.service';

/** Guarda o último `painel/resumo` para evitar chamadas repetidas entre telas. */
@Injectable({ providedIn: 'root' })
export class PainelResumoStore {
  private readonly painel = inject(PainelService);
  private readonly resumoSignal = signal<PainelResumoDTO | null>(null);

  readonly resumo = this.resumoSignal.asReadonly();

  /** Busca `painel/resumo`, atualiza o signal e devolve o resultado. */
  atualizar(): Observable<PainelResumoDTO> {
    return this.painel.resumo().pipe(tap((r) => this.resumoSignal.set(r)));
  }
}
